<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <!-- Écrire les majuscules Â, Ê, Î, Ô, Û, Ä, Ë, Ï, Ö, Ü, À, Æ, æ - La ... -->
      <h4> {{ detail__detail ? 'QUALIFIER LA REQUÊTE' : 'DÉTAILS DE LA DEMANDE' }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer" />
    </div>
    <vs-divider class="mb-0" />
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="px-6 py-2" v-if="charger || commercial">
        <vs-button :disabled="!agentCanQualify || !requestIsFree ? true : false" class="mr-6" @click="base.input.id = base.affiche.id, base.input.title = base.affiche.title, base.input.email = base.affiche.email,
          base.input.request_content = base.affiche.content, detail__detail = !detail__detail">{{ !detail__detail ?
    'Qualifier la requête' : 'Détails de la demande' }}</vs-button><br>
        <span v-if="!agentCanQualify && ($store.state.is_chargerClientele())" style="color: #ff6141">Vous avez au moins
          3 requêtes en attente de traitement</span>
        <span v-if="agentCanQualify && ($store.state.is_chargerClientele()) && !requestIsFree"
          style="color: #ff6141">Cette demande est en cours de consultation par un autre agent</span>
      </div>
      <div v-if="!detail__detail" class="px-6">
        <p class="mt-5">Titre de la demande </p>
        <vs-input :disabled="true" v-model="base.affiche.title" class="w-full" name="item-code" />
        <p class="mt-5">E-mail </p>
        <vs-input :disabled="true" v-model="base.affiche.email" class="w-full" name="item-code" />
        <!-- <vs-textarea :disabled="true" rows="10" label="Description" v-model="base.affiche.content" class="mt-5 w-full" /> -->
        <p class="mt-10">Description</p>
        <div class="mt-2" v-html="base.affiche.content"></div>
      </div>
      <div v-if="detail__detail" class="p-6">

        <template v-if="$store.state.is_client() || $store.state.is_mandataire()">
          <div class="flex justify-between">
            <div><span>Contrat</span> <span class="font-bold">{{ base.input.contract }}</span></div>
            <div><span class="text-primary underline cursor-pointer" @click="popupActive = true">Changer</span></div>
          </div>

          <vs-popup class="holamundo" title="Changer le contract" :active.sync="popupActive">
            <p class="mt-5">Contrat <b style="color: #ff6141">*</b> </p>
            <v-select :reduce="rep => rep.id" class="w-full" label="code_contract" v-model="base.input.contract_id"
              :options="base.customers_contracts"></v-select>
            <vs-button class="mt-3" @click="popupActive = false">Valider</vs-button>
          </vs-popup>
        </template>

        <template v-else>
          <p class="mt-5">Ajouter plusieurs demandes</p>
          <vs-checkbox v-model="base.input.again"></vs-checkbox>
          <p class="mt-5">Client <b style="color: #ff6141">*</b> </p>
          <v-select :reduce="rep => rep.id" class="w-full" label="social_reason" v-model="base.input.customer_id"
            :options="base.customers"></v-select>

          <p v-if="base.input.customer_id" class="mt-5">Contrat <b style="color: #ff6141">*</b> </p>
          <v-select v-if="base.input.customer_id" :reduce="rep => rep.id" class="w-full" label="code_contract"
            v-model="base.input.contract_id" :options="base.customers_contracts"></v-select>
        </template>


        <!-- NAME -->
        <p class="mt-5">Titre de la demande <b style="color: #ff6141">*</b> </p>
        <vs-input v-model="base.input.title" class="w-full" name="item-name" />


        <p class="mt-5">Type de demande <b style="color: #ff6141">*</b> </p>
        <v-select :reduce="rep => rep.id" class="w-full" label="name" v-model="base.input.type_request_id"
          :options="base.categories_requests"></v-select>

        <p v-if="base.input.type_request_id" class="mt-5">Sous-type de demande <b style="color: #ff6141">*</b> </p>
        <v-select v-if="base.input.type_request_id" :reduce="rep => rep.id" class="w-full" label="name"
          v-model="base.input.subtype_request_id" :options="base.sub_categories_requests"></v-select>

        <p class="mt-5">Priorité <b style="color: #ff6141">*</b> </p>
        <v-select :reduce="rep => rep.id" class="w-full" label="name" v-model="base.input.priority_id"
          :options="base.priorities"></v-select>

        <!-- <p class="mt-5" v-if="base.input.priority_id" >Urgence (Service Now) <b style="color: #ff6141">*</b> </p>
                <v-select v-if="base.input.priority_id" :reduce="rep => rep.id" class="w-full" label="name" v-model="base.input.urgency_id" :options="base.urgencies"></v-select> -->

        <!-- <p class="mt-5" v-if="base.input.urgency_id" >Urgence (Service Now) <b style="color: #ff6141">*</b> </p>
                <v-select v-if="base.input.urgency_id" :reduce="rep => rep.id" class="w-full" label="name" v-model="base.input.impact_id" :options="base.impacts"></v-select> -->

        <p class="mt-5" v-if="dispatcher">Assigné la requête à:</p>
        <v-select v-if="dispatcher" :reduce="rep => rep.id" class="w-full" label="name" v-model="base.input.user_assign"
          :options="charger"></v-select>

        <p class="mt-5">Votre demande <b style="color: #ff6141">*</b></p>
        <!-- <vs-textarea v-model="base.input.request_content" rows="10" class="w-full" name="item-request" /> -->
        <editor api-key="vsog9xkjmfz9ep56eol3c5z8er4yulqg4ffcu96t3k56zpg5" :init="editorInit"
          v-model="base.input.request_content" />
      </div>
      <div v-if="base.affiche.upload.length > 0" class="mt-5 px-6 py-2" v-for="(attachment, index) in base.affiche.upload"
        :key="index" @click.stop="exportToExcel(attachment)">
        <vs-chip color="grey" class="ml-2 mr-3 cursor-pointer">
          <vs-avatar icon="cloud_download" />
          {{ attachment.name }}
        </vs-chip>
      </div>

    </VuePerfectScrollbar>
    <div v-if="detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button v-if="charger || commercial" class="mr-6" @click="submitData"
        :disabled="!isFormValid">Soumettre</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
var base_self;
var input_tempon = {
  id: null,
  name: '',
  comment: ''
};

import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Editor from '@tinymce/tinymce-vue';

export default {
  components: { VuePerfectScrollbar, 'editor': Editor },
  props: {
    base: {
      type: Object,
      required: true
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => { },
    },
    dispatcher: {
      type: Boolean,
      default: false
    },
    commercial: {
      type: Boolean,
      default: false
    },
    charger: {
      type: Array,
      default: () => []
    },
    agentCanQualify: {
      type: Boolean,
      default: () => false
    },
    requestIsFree: {
      type: Boolean,
      default: () => false
    },
  },
  data() {
    return {
      editorInit: {
        height: 300,
        menubar: false,
        plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount'
        ],
        toolbar:
          'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | help'
      },
      error: {
        name: false
      },
      input: {},
      detail__detail: false,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      var is_valide = true;
      if (!this.base.input.contract_id || this.base.input.contract_id === '') is_valide = false;
      if (this.$store.state.is_chargerClientele() && (!this.base.input.customer_id || this.base.input.customer_id === '')) is_valide = false;
      if (!this.base.input.title || this.base.input.title === '') is_valide = false;
      if (!this.base.input.type_request_id || this.base.input.type_request_id === '') is_valide = false;
      if (!this.base.input.subtype_request_id || this.base.input.subtype_request_id === '') is_valide = false;
      if (!this.base.input.priority_id || this.base.input.priority_id === '') is_valide = false;
      if (!this.base.input.request_content || this.base.input.request_content === '') is_valide = false;
      // if (!this.base.input.urgency_id || this.base.input.urgency_id === '') is_valide = false;
      // if (!this.base.input.impact_id || this.base.input.impact_id === '') is_valide = false;

      return is_valide;
    },
    verification_name() {
      return (base_self.input.name.length !== 0) ? false : true;
    }
  },
  methods: {
    exportToExcel(el) {
      this.$vs.loading()
      this.$http({
        url: '/outlook/download',
        method: 'POST',
        responseType: 'blob',
        data: { file: el.name }
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', el.name)
        document.body.appendChild(link)
        link.click()
        this.$vs.loading.close()
      }).catch((error) => {
        this.$vs.loading.close()
        if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({ name: "login" })
        }
      })
    },
    openinnewwindows(url) {
      window.open(url, "_blank");
    },
    async submitData() {
      this.$vs.loading()
      var input = JSON.parse(JSON.stringify(this.base.input));
      let response = await base_self.$store.state.outlook_qualify_request(input);
      //console.log('response: ', response);
      if (response.data.status) {
        window.GETCCMT.success('La qualification de la requette a réussi.', response);
        //console.log('response: ', response);
        this.$vs.loading.close()
        if (!input.again) {
          this.$emit('closeSidebar', false);
          await this.base.outlook(this.base.page)
        }
        //base_self.$router.push('/requests');
        // this.initValues()
      } else {
        this.$vs.loading.close()
        window.GETCCMT.error({ message: response.data.message ? response.data.message : 'La qualification de la requette a échouée.' });
      }
    },
    initValues() {
      this.input = JSON.parse(JSON.stringify(input_tempon));
      this.detail__detail = false;
      window.MailRequestsApp.sidebarData.detail__detail = false;
    }
  },
  watch: {
    async isSidebarActive() {
      this.initValues();
      if (window.MailRequestsApp.sidebarData.id) {
        let response = await base_self.$store.state.categories_requests_detail({}, window.MailRequestsApp.sidebarData.id);

        this.input = JSON.parse(JSON.stringify(response.data));
        //console.log('categories_requests_detail response :    ::::::::::::::::::::::::', response);

        this.detail__detail = window.MailRequestsApp.detail__detail;
      }
    }
  },
  created() {
    window.EditCategory = this;
    base_self = this;
    base_self.initValues()
  }

}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 650px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
